import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import { colors } from '../styles/colors'
import VoteIoError from '../svgr/VoteIoError'
import { DialogCloseButton } from '../components/DialogCloseButton'

export const ActionRejectedDialog: FC<{
  onRetry: () => void
  isLoading: boolean
  onClose?: () => void
  title?: string
  description?: string
}> = ({ onRetry, title, description, onClose, isLoading }) => {
  return (
    <DialogContainer>
      {onClose && <DialogCloseButton onClick={onClose} />}

      <IconContainer>
        <VoteIoError />
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            {title ? (
              title
            ) : (
              <FormattedMessage
                id="dialog.actionRejected.title"
                defaultMessage="Отклонено"
              />
            )}
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography
            fontSize={14}
            fontWeight={400}
            color={colors.secondary}
            font="roboto"
          >
            {description ? (
              description
            ) : (
              <FormattedMessage
                id="dialog.actionRejected.description"
                defaultMessage="Попробуйте снова через несколько минут"
              />
            )}
          </Typography>
        </DescriptionContainer>
      </ContentContainer>

      <ButtonContainer>
        <RetryButton
          onClick={onRetry}
          textColor={colors.white}
          textWeight={700}
          loading={isLoading}
        >
          <FormattedMessage
            id="dialog.actionRejected.retry"
            defaultMessage="Повторить"
          />
        </RetryButton>
      </ButtonContainer>
    </DialogContainer>
  )
}

export const actionRejectedDialogPath = '/action-rejected-dialog'

const DialogContainer = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  gap: 48px;
  background: ${colors.bgPrimary};
  border-radius: 20px;
  padding: 48px 32px;
  width: 100%;
  max-width: 400px;
  text-align: center;
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 280px;
`

const RetryButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
  color: ${colors.white};
`
